import React from 'react';

export default function TermsAndConditions() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-4xl md:text-5xl font-bold mb-8 text-[#09848B]">
        Terms of Service
      </h1>
      
      <div className="space-y-6 text-lg text-black">
        <section>
          <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
          <p>
            Welcome to Property Hall Investment Ltd ("Company," "we," "our," or "us"). By accessing or using our platform, website, and services (collectively, the "Services"), you agree to comply with and be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please refrain from using our Services.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">2. Definitions</h2>
          <p>
            "User" refers to any person who accesses or uses our platform, including buyers, sellers, landlords, tenants, and agents.
          </p>
          <p>
            "Buyer" refers to an individual or entity seeking to purchase property through our platform.
          </p>
          <p>
            "Seller" refers to an individual or entity listing a property for sale.
          </p>
          <p>
            "Landlord" refers to a property owner listing rental properties.
          </p>
          <p>
            "Tenant" refers to an individual renting a property through our platform.
          </p>
          <p>
            "Verified Agent" refers to a licensed real estate professional registered on our platform.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">3. Eligibility</h2>
          <p>
            To use our Services, you must:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Be at least 18 years old and legally capable of entering into binding agreements.</li>
            <li>Provide accurate and truthful information during registration and transactions.</li>
            <li>Comply with all applicable laws and regulations governing real estate transactions in Kenya.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">4. Property Listings and Transactions</h2>
          <h3 className="text-xl font-medium mb-2">4.1 Verified Listings</h3>
          <p>
            Property Hall ensures that all properties listed on the platform are verified to minimize fraud. However, we do not guarantee the condition, legality, or completeness of property listings and advise buyers and tenants to conduct due diligence.
          </p>
          
          <h3 className="text-xl font-medium mt-4 mb-2">4.2 Payment Handling & Security</h3>
          <p>
            To enhance security in real estate transactions, Property Hall acts as a third-party escrow service:
          </p>
          
          <h4 className="font-semibold mt-3">For Land Purchases</h4>
          <p>
            The buyer pays the full amount upfront, which is securely held by Property Hall.
          </p>
          <p>
            The seller receives payment only after the legal transfer of the title deed to the buyer is successfully completed.
          </p>
          
          <h4 className="font-semibold mt-3">For Rental Transactions</h4>
          <p>
            The tenant pays the required rent and deposit upfront.
          </p>
          <p>
            The landlord receives payment only after the tenant has moved in and completed the necessary verification process.
          </p>
          <p>
            Property Hall is not responsible for disputes between buyers and sellers or landlords and tenants after transactions are completed.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">5. User Responsibilities</h2>
          <p>
            By using our platform, you agree to:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide accurate information during property transactions.</li>
            <li>Abide by contractual agreements when purchasing, selling, or renting properties.</li>
            <li>Respect payment terms and not engage in fraudulent activity.</li>
            <li>Comply with local real estate regulations and laws.</li>
          </ul>
          <p className="mt-3">
            Failure to adhere to these responsibilities may result in account suspension or legal action.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">6. Fees and Payments</h2>
          <p>
            Property Hall may charge service fees for listing, verification, or escrow services.
          </p>
          <p>
            Fees, if applicable, will be disclosed upfront and are non-refundable unless stated otherwise.
          </p>
          <p>
            Payment transactions on the platform are processed securely, and Property Hall is not liable for any unauthorized access to payment information.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">7. Dispute Resolution</h2>
          <p>
            In the event of a dispute:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Parties must first attempt to resolve issues amicably through mutual discussion.</li>
            <li>If unresolved, Property Hall may provide mediation services but does not act as a legal arbitrator.</li>
            <li>Legal disputes shall be governed under the laws of Kenya and resolved in Kenyan courts.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">8. Limitation of Liability</h2>
          <p>
            Property Hall does not own or control the properties listed on the platform. We act as a facilitator for secure transactions.
          </p>
          <p>
            We are not liable for any financial losses, disputes, damages, or delays arising from property transactions.
          </p>
          <p>
            Users are solely responsible for verifying the legality and condition of properties before making commitments.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">9. Privacy Policy</h2>
          <p>
            Your privacy is important to us. We collect, store, and use your personal information in accordance with our Privacy Policy, which explains how we protect your data.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">10. Amendments to Terms</h2>
          <p>
            We reserve the right to update or modify these Terms of Service at any time. Users will be notified of significant changes, and continued use of the platform constitutes acceptance of the revised terms.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">11. Contact Us</h2>
          <p>
            For any inquiries or concerns regarding these Terms, please contact us at:
          </p>
          <ul className="space-y-1 mt-2">
            <li>📍 Property Hall Investment Ltd</li>
            <li>📞 [+254 721552820]</li>
            <li>📧 [info@propertyhall.net]</li>
            <li>🌍 [propertyhall.net]</li>
          </ul>
        </section>
      </div>
    </div>
  );
}